import React, { useState } from "react";
import { Checkbox } from "@blueprintjs/core";
import styles from "./SelectList.module.scss";
import { distinct } from "../../helpers/JSONTransformations";
import { SelectItem } from "./SelectItem";

export function NestedSelectItem({ value, setValue, data }) {
  const getChildValues = (arr) =>
    arr
      .map((elem) =>
        elem.children ? getChildValues(elem.children) : elem.value
      )
      .flat();

  const { children } = data;
  const childValues = getChildValues(children);
  const isChecked = childValues.every((elem) => value.includes(elem));
  const isIndeterminate = childValues.some((elem) => value.includes(elem));

  const removeAll = () => {
    let newVal = value.filter((elem) => childValues.indexOf(elem) == -1);
    setValue(newVal);
  };

  const addAll = () => {
    let newVal = distinct([...childValues, ...value]);
    setValue(newVal);
  };

  const onChange = (event) => {
    event.target.checked ? addAll() : removeAll();
  };

  return (
    <>
      <Checkbox
        checked={isChecked}
        onChange={onChange}
        indeterminate={!isChecked && isIndeterminate}
        className={styles.checkBox}
        large={true}
      >
        <span className={styles.checkBoxLabel}>
          {data.imageUrl && <img src={data.imageUrl} />}
          {data.text}
        </span>
      </Checkbox>
      <div className={styles.childSelectList}>
        {data.children.map((item) =>
          item.children && item.children.length ? (
            <NestedSelectItem
              key={item.value}
              value={value}
              setValue={setValue}
              data={item}
            />
          ) : (
            <SelectItem
              key={item.value}
              value={value}
              setValue={setValue}
              data={item}
            />
          )
        )}
      </div>
    </>
  );
}
